import { PropsWithChildren } from 'react';

import { Label } from '@/components/ui/label';

type LabeledFieldProps = PropsWithChildren<{
  label: string;
  /**
   * Id of the control this labels. Required rather than optional: the MUI version rendered a
   * bare FormLabel with nothing tying it to its input, so clicking the label did nothing and
   * screen readers announced the field unlabelled.
   */
  htmlFor: string;
}>;

export function LabeledField({ label, htmlFor, children }: LabeledFieldProps) {
  // gap-1.5 is the 6px §6 asks for between a field label and its control.
  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor={htmlFor}>{label}</Label>
      {children}
    </div>
  );
}

